// src/api/referApi.js
import api from "../configs/axiosConfig";

// GET /refer/overview
export async function getReferOverview(userId, referId) {
  const response = await api.get(`/refer/get_user_refered/${userId}/${referId}`);
  return response.data;
}
